import { render, staticRenderFns } from "./beginDialog.vue?vue&type=template&id=84ef04ac&scoped=true"
import script from "./beginDialog.vue?vue&type=script&lang=js"
export * from "./beginDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ef04ac",
  null
  
)

export default component.exports